var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLittleStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9583 5.82491C15.9071 5.66636 15.8104 5.52637 15.6802 5.42239C15.5501 5.31842 15.3922 5.25506 15.2262 5.24021L10.6082 4.82085L8.78209 0.546681C8.6474 0.233454 8.34077 0.0307617 8.00007 0.0307617C7.65937 0.0307617 7.35271 0.233486 7.21808 0.547462L5.39197 4.82088L0.7732 5.24021C0.607451 5.25539 0.449802 5.31888 0.3198 5.42282C0.189799 5.52676 0.0931609 5.66657 0.0418688 5.82491C-0.0634776 6.14892 0.0338061 6.50427 0.290531 6.72828L3.78125 9.7896L2.75191 14.3238C2.67659 14.6572 2.80597 15.0018 3.0826 15.2017C3.23126 15.3092 3.40524 15.3639 3.58065 15.3639C3.7319 15.3639 3.8819 15.3231 4.01659 15.2425L8.00007 12.8617L11.9821 15.2425C12.2735 15.4178 12.6408 15.4018 12.9168 15.2017C13.0519 15.1039 13.1553 14.9686 13.2141 14.8125C13.2729 14.6564 13.2845 14.4864 13.2475 14.3238L12.2182 9.7896L15.7089 6.7289C15.8345 6.61923 15.925 6.47508 15.9694 6.31437C16.0137 6.15365 16.0099 5.98345 15.9583 5.82491Z",
    fill: "#FFDB34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleStar);
export default __webpack_public_path__ + "static/media/little-star.d6fecc367fe26ad121bfa1e4d3b3d122.svg";
export { ForwardRef as ReactComponent };